import WelcomeBanner from './WelcomeBanner'
export default WelcomeBanner
